/* eslint-disable  @typescript-eslint/no-explicit-any */
import { ResponseError } from 'remotes/@api/authorization_v4';

export enum LocalStorageKeys {
    needBiometric = 'needBiometric',
    canBiometricAuth = 'canBiometricAuth',
}

/**
 * @description Check error is ResponseError.
 * @param {any} err - Error.
 * @returns {boolean} Return true if error is ResponseError.
 */
export function isServiceResponse(err: any): err is ResponseError {
    return 'response' in err;
}

/**
 * @description GetNeedBiometric.
 * @returns {boolean} NeedBiometric.
 */
export function getNeedBiometric() {
    return localStorage.getItem(LocalStorageKeys.needBiometric) === 'true';
}

/**
 * @description SetNeedBiometric.
 * @param {boolean} needBiometric - NeedBiometric.
 */
export function setNeedBiometric(needBiometric: boolean) {
    localStorage.setItem(LocalStorageKeys.needBiometric, String(needBiometric));
}

/**
 * @description GetCanBiometricAuth.
 * @returns {boolean} CanBiometricAuth.
 */
export function getCanBiometricAuth(): boolean {
    return localStorage.getItem(LocalStorageKeys.canBiometricAuth) === 'true';
}

/**
 * @description CanBiometricAuth.
 * @param {boolean} canBiometricAuth - CanBiometricAuth.
 */
export function setCanBiometricAuth(canBiometricAuth: boolean) {
    localStorage.setItem(
        LocalStorageKeys.canBiometricAuth,
        String(canBiometricAuth),
    );
}
